import { useMutation, useQueryClient } from '@tanstack/react-query';

import { excludeCreatorMutationOptions } from '@/entities/exclude-list';
import { useWorkspace } from '@/shared/hooks/use-workspace';
import { trackEvent } from '@/shared/track';

export function useExcludeDiscoveryCreatorMutation() {
  const queryClient = useQueryClient();
  const { workspace } = useWorkspace();
  const options = excludeCreatorMutationOptions(queryClient, workspace.id);

  return useMutation({
    ...options,
    onSuccess: async (data, variables, onMutateResult, context) => {
      await options.onSuccess?.(data, variables, onMutateResult, context);
      trackEvent('Exclude_list', 'add_exclude', {
        creator_id: data.creator_id,
      });
    },
  });
}
